import { ComponentProps, forwardRef, ForwardRefExoticComponent, LegacyRef, useEffect } from 'react'
import React from 'react'
import { Popover, PopoverButton, PopoverPanel, useClose } from '@headlessui/react'
import cn from 'classnames'

import { ButtonPrimary } from './ButtonPrimary'
 

export const PopoverModal = ({
  children,
  position,
  openButton: OpenButtonProp,
  shouldClose,
  onClose,
  className
}) => {
  const OpenButton = forwardRef(function (props, ref) {
    // @ts-expect-error open prop
    const { open, ...restProps } = props
    const close = useClose()

    useEffect(() => {
      if (shouldClose) {
        close()
        onClose && onClose()
      }
    }, [close])

    return OpenButtonProp ?
        // @ts-expect-error open prop
        <OpenButtonProp ref={ref} open={open} {...restProps} />
      : <ButtonPrimary ref={ref} {...restProps} />
  })

  OpenButton.displayName = 'OpenButton'

  return (
    <Popover>
      {({ open }) => (
        <>
          {/** @ts-expect-error open prop */}
          <PopoverButton open={open} as={OpenButton} />
          <PopoverPanel
            style={{ zIndex: 20 }}
            transition
            anchor={position || { to: 'top', gap: '16px' }}
            className={cn(
              'rounded-lg bg-white border border-gray-200 shadow-lg !overflow-visible',
              className
            )}
          >
            {children}
          </PopoverPanel>
        </>
      )}
    </Popover>
  )
}

PopoverModal.displayName = 'PopoverModal'
